import { Layout } from './components/Layout'
import { RequireAuth } from './components/RequireAuth'
import { Automation } from './pages/Automation'
import { BookingDetail } from './pages/BookingDetail'
import { BookingNew } from './pages/BookingNew'
import { Calendar } from './pages/Calendar'
import { ClientDetail } from './pages/ClientDetail'
import { Clients } from './pages/Clients'
import { Enquiries } from './pages/Enquiries'
import { EnquiryDetail } from './pages/EnquiryDetail'
import { InvoiceDetail } from './pages/InvoiceDetail'
import { Invoices } from './pages/Invoices'
import { Lab } from './pages/Lab'
import { Login } from './pages/Login'
import { NotFound } from './pages/NotFound'
import { Overview } from './pages/Overview'
import { Team } from './pages/Team'

/** Kept out of main.tsx so tests can mount the real routing without booting the app. */
export const ROUTES = [
  { path: '/login', element: <Login /> },
  {
    element: (
      <RequireAuth>
        <Layout />
      </RequireAuth>
    ),
    children: [
      { path: '/', element: <Overview /> },
      { path: '/enquiries', element: <Enquiries /> },
      { path: '/enquiries/:id', element: <EnquiryDetail /> },
      { path: '/calendar', element: <Calendar /> },
      { path: '/bookings/new', element: <BookingNew /> },
      { path: '/bookings/:id', element: <BookingDetail /> },
      { path: '/clients', element: <Clients /> },
      { path: '/clients/:id', element: <ClientDetail /> },
      { path: '/invoices', element: <Invoices /> },
      { path: '/invoices/:id', element: <InvoiceDetail /> },
      { path: '/automation', element: <Automation /> },
      { path: '/lab', element: <Lab /> },
      { path: '/team', element: <Team /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]
